import React from 'react';
import type { IconProps } from '../types';

export const CheckCircle = (props: IconProps) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.16667 0C4.10406 0 0 4.10406 0 9.16667C0 14.2293 4.10406 18.3333 9.16667 18.3333C14.2293 18.3333 18.3333 14.2293 18.3333 9.16667C18.3333 4.10406 14.2293 0 9.16667 0ZM13.5059 7.25592C13.8314 6.93048 13.8314 6.40285 13.5059 6.07741C13.1805 5.75197 12.6528 5.75197 12.3274 6.07741L7.91667 10.4882L6.00592 8.57741C5.68049 8.25197 5.15285 8.25197 4.82741 8.57741C4.50197 8.90285 4.50197 9.43048 4.82741 9.75592L7.32741 12.2559C7.65285 12.5814 8.18048 12.5814 8.50592 12.2559L13.5059 7.25592Z"
      fill="#16A34A"
    />
  </svg>
);

export default CheckCircle;
